<template>
  <div>
    <CustomPageHeaderVue>{{ $t('userinfo_title') }}</CustomPageHeaderVue>
    <CustomRow>
      <div class="mt-5 d-flex text-title">
        <div class="cus-tab left-tab cursor-pointer text-regular text-sm-big-title" :class="{ inactive: tabSelect !== 1 }"
          @click="changeTab(1)">
          {{ $t('userinfo_memberinfo_tab') }}
        </div>
        <div class="cus-tab center-tab cursor-pointer text-regular text-sm-big-title"
          :class="{ inactive: tabSelect !== 2 }" @click="changeTab(2)">
          {{ $t('userinfo_creditcard_tab') }}
        </div>
        <div class="cus-tab right-tab cursor-pointer text-regular text-sm-big-title"
          :class="{ inactive: tabSelect !== 3 }" @click="changeTab(3)
            ">
          {{ $t('userinfo_change_password_tab') }}
        </div>
      </div>
      <v-card class="py-15 tab-content">
        <UserInfoForm v-if="tabSelect == 1" />
        <CreditcardManagement v-if="tabSelect == 2" />
        <ChangePassword v-if="tabSelect == 3" />
      </v-card>
    </CustomRow>
  </div>
</template>

<script>
import UserInfoForm from "../components/UserInfoForm.vue";
import CreditcardManagement from "../components/CreditcardManagement.vue";
import ChangePassword from "../components/ChangePassword.vue";
import CustomPageHeaderVue from "@/components/CustomPageHeader.vue";

export default {
  props: ["urlTabSelect"],
  components: {
    UserInfoForm,
    CreditcardManagement,
    ChangePassword,
    CustomPageHeaderVue
  },
  metaInfo() {
    return {
      title: `${this.$t('userinfo_title')} - ${this.$t('app_name')}`,
      script: [{
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": `${this.$t('userinfo_title')} - ${this.$t('app_name')}`,
          "url": window.location.href
        }
      }]
    }
  },
  mounted() {
    setTimeout(() => {
      this.$gtm.trackView(`UserInfo`, this.$route.path);
    }, 200);
  },
  computed: {
    tabSelect() {
      return parseInt(this.urlTabSelect) || 1;
    }
  },
  methods: {
    changeTab(index) {
      this.$router.push({ name: 'UserInfo', params: { urlTabSelect: index } }).catch(() => { })
    }
  }
};
</script>

<style lang="scss" scoped>
.cus-tab {
  width: 50%;
  position: relative;
  z-index: 0;
  display: flex;
  align-content: center;
  justify-content: center;
  line-height: 1.5;
  padding-top: 9px;
  padding-bottom: 9px;
  text-align: center;
  font-weight: bold;
  color: #444444;

  &.left-tab {
    z-index: 1;

    &.inactive {
      z-index: 0;
    }

    &::before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      outline: 1px solid transparent;
      border-radius: $radiusDesktop $radiusDesktop 0 0;
      background: white;
      content: "";
      -webkit-transform: perspective(5px) rotateX(0.93deg) translateZ(-1px);
      transform: perspective(8px) rotateX(1.1deg) translateZ(-1px);
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      box-shadow: -2px -2px 6px 0px rgb(0 0 0 / 9%);
    }
  }

  &.center-tab {
    z-index: 1;

    &.inactive {
      z-index: 0;
    }

    &::before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      outline: 1px solid transparent;
      border-radius: $radiusDesktop $radiusDesktop 0 0;
      background: white;
      content: "";
      -webkit-transform: perspective(5px) rotateX(0.93deg) translateZ(-1px);
      transform: perspective(20px) rotateX(5.1deg) translateZ(0px);
      -webkit-transform-origin: 0 0;
      transform-origin: 50% 0;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      box-shadow: 0px -8px 13px -1px rgb(0 0 0 / 9%);
    }
  }

  &.right-tab {
    z-index: 1;
    padding-left: 20px;

    &.inactive {
      z-index: 0;
    }

    &::before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      outline: 1px solid transparent;
      border-radius: $radiusDesktop $radiusDesktop 0 0;
      background: white;
      content: "";
      -webkit-transform: perspective(5px) rotateX(0.93deg) translateZ(-1px);
      transform: perspective(8px) rotateX(1.1deg) translateZ(-1px);
      -webkit-transform-origin: 100% 0;
      transform-origin: 100% 0;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      box-shadow: 2px -2px 6px 0px rgb(0 0 0 / 9%);
    }
  }

  &.inactive {
    font-weight: 400;
  }

  @media screen and (max-width: 600px) {

    &.left-tab::before,
    &.center-tab::before,
    &.right-tab::before {
      border-radius: $radiusMobile $radiusMobile 0 0;
    }
  }
}

.inactive::before {
  background: rgb(224 224 224 / 73%) !important;
  box-shadow: inset 0 -3px 3px rgb(0 0 0 / 5%) !important;
}

.center-tab.inactive::before {
  background: rgb(224 224 224 / 73%) !important;
  box-shadow: inset 0 -8px 3px rgb(0 0 0 / 5%) !important;
}

.tab-content {
  position: relative;
  top: -1px;
  background: white;
  border-radius: 0 0 $radiusDesktop $radiusDesktop;
  box-shadow: 0px 7px 7px 1px rgb(0 0 0 / 9%);

  @media screen and (max-width: 600px) {
    border-radius: 0 0 $radiusMobile $radiusMobile;
  }
}

@media screen and (max-width: 600px) {
  .cus-tab {
    font-size: 14px;
  }
}
</style>
